import { createAction } from 'typesafe-actions';
import type { TeamID } from '@common/ids';

import type {
    TeamMemberUser,
    Player,
    UserRolloverAssociation,
    PlayerRolloverAssocation,
    PlayerID,
    PlayerVideoClip,
    VideoClipID,
    AthleteProfile,
} from './types';

export const addTeamMemberUsers = createAction(
    'teammemberuser/ADD',
    (wrapPayload) => (teamMemberUsers: TeamMemberUser[]) => wrapPayload(teamMemberUsers),
);

export const addPlayers = createAction(
    'player/ADD',
    (wrapPayload) => (teamID: TeamID, players: Player[]) => wrapPayload({ teamID, players }),
);

export const addRolloverOptions = createAction(
    'rolloverOptions/add',
    (wrapPayload) =>
        (rolloverOptions: {
            fans: UserRolloverAssociation[];
            staff: UserRolloverAssociation[];
            players: PlayerRolloverAssocation[];
        }) =>
            wrapPayload(rolloverOptions),
);

export const addPlayerVideoClips = createAction(
    'videoclip/player/ADD',
    (wrapPayload) => (playerID: PlayerID, videoClips: PlayerVideoClip[]) => wrapPayload({ playerID, videoClips }),
);

export const setPlayerVideoClipUrl = createAction(
    'videoclipUrl/player/ADD',
    (wrapPayload) => (playerID: PlayerID, clipID: VideoClipID, url: string) => wrapPayload({ playerID, clipID, url }),
);

export const setAthleteProfileAndClipsPublic = createAction(
    'public/athlete-profile/set',
    (wrapPayload) => (athleteProfile: AthleteProfile) => wrapPayload({ athleteProfile }),
);
